/**
 * On an investigation's page: the hypothesis it is evidence for ("supports H1", ADR-0095), named
 * from the case's hypotheses. Nothing while the investigation is evidence for none, or while the
 * name is still being read.
 */
import { HypothesisLinkChip } from '@/components/analytic-hypotheses/HypothesisLinkChip'
import { hypothesisPath } from './paths'
import { useAnalyticHypotheses } from './queries'

export function InvestigationHypothesisChip({
  caseId,
  hypothesisRef,
}: {
  caseId: string
  hypothesisRef: string | null | undefined
}) {
  const { data } = useAnalyticHypotheses(caseId)
  const hypothesis = hypothesisRef
    ? data?.hypotheses.find(item => item.id === hypothesisRef)
    : undefined
  if (!hypothesis) return null
  return <HypothesisLinkChip title={hypothesis.title} to={hypothesisPath(caseId, hypothesis.id)} />
}
